<script setup lang="ts">
import type { NotificationDocument } from "@kekkle/shared/types/documents/notification-document/notification-document";
import NotificationItem from "@/components/notifications/NotificationItem.vue";

type Props = {
  notifications: NotificationDocument[];
};

type Emits = {
  (e: "select", notification: NotificationDocument): void;
};

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="mb-4 grow space-y-2.5 overflow-y-auto px-1.5 py-1 pb-8">
    <NotificationItem
      v-for="notification in notifications"
      :key="notification._id"
      :notification="notification"
      @click="emit('select', notification)"
    />
  </div>
</template>
